/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./statisticsReport.vue?vue&type=template&id=19e16d2a&scoped=true"
import script from "./statisticsReport.vue?vue&type=script&lang=js"
export * from "./statisticsReport.vue?vue&type=script&lang=js"
import style0 from "./statisticsReport.vue?vue&type=style&index=0&id=19e16d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e16d2a",
  null
  
)

export default component.exports